export const RECENT_EVENT_DATA_MAX_DAYS_FLAG = 'track-thing-detail-recent-alerts-card-days-backward-feature';
export const TRACK_FAULTS_UI_TEMPLATE_ENABLEMENT_FLAG = 'track-faults-ui-template-enablement';
export const TRACK_FAULT_REQUEST_SETTINGS_FLAG = 'track-fault-request-settings';
export const SHOW_DELETED_BY_DEFAULT_FLAG = 'portals-things-list-show-deleted-things-by-default-feature';
export const DISPLAY_ACTIVITIES_FEATURE_FLAG = 'track-history-display-activities-feature';
export const FAULTS_VIEW_FLAG = 'track-history-faults-view-feature';
export const TRUSTED_ACTIVITIES_RULES_FLAG = 'track-history-trusted-activities-rules';
export const UI_TEMPLATE_DRIVEN_SIDEBAR_FLAG = 'portals-ui-template-driven-sidebar-temporary';
export const UI_TEMPLATE_DRIVEN_MAP_LAYERS_FLAG = 'portals-ui-template-driven-map-layers-temporary';
export const MAP_ZOOM_LIMITS_FLAG = 'track-min-max-zoom-feature';
